import { Component, EventEmitter, Input, NgZone, OnInit, Output, SimpleChange, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { MapService } from 'src/app/Services/map.service';
import { StorageService } from 'src/app/Services/storage.service';

declare var google: any;

@Component({
  selector: 'location-pickup',
  templateUrl: './location-pickup.component.html',
  styleUrls: ['./location-pickup.component.css']
})
export class LocationPickupComponent implements OnInit {

  //@Input() class:string = "col-12";
  @Input() fieldSize: string;
  @Input() modalTitle: string;
  @Input() controlName: string;
  @Input() form: FormGroup;
  @Input() edit: boolean = false;
  @Input() mandatory: boolean = true;
  @Input() locationData;
  @Input() formSubmit: boolean;
  @Output() result: any = new EventEmitter();
  @Input() googleSearch:boolean = true;

  get isValid() { return this.form.controls[this.controlName].valid; }
  get isDirty() { return this.form.controls[this.controlName].dirty; }

  @ViewChild('modalHide') modalHide;
  public showMap:boolean = false;
  public mapSearchChangeObserver: any;
  mapSearchDebounceTimeOut = null;
  mapSearchDataLists = [];

  public locationMap: any;
  public selectedValueClose = false;
  public locValueClear: boolean = false;
  public markerId = 'pickLocation' + Math.round(Math.random() * 10000);
  public locationObj = {};
  public locationSuggestions = {};
  public submittedObj = {};

  public checkLoc: boolean = false;
    //for map
  public selectedMap:string='osrm';
  // public selectedMap:string='google';
  private googleMapObj: any;
  public geocoder:any;
  public markerLoc: string;
  public markersArray = [];

  constructor(private mapService: MapService,
    public ngZone:NgZone,
    public storage: StorageService,
    public api:ApiService
    ) {
      let user= this.storage.get('userInfo');
      if(user && user.map){
        this.selectedMap = user.map; 
      }
      this.loadMap();
  }

  ngOnInit(): void {
    this.scrollToPageTop();
    /*   if (this.edit) {
        this.locationObj = { ...this.locationData}
        this.selectedValue(this.locationObj)
      } */
     console.log("Enter load map")
  }
  ngOnChanges(changes: SimpleChange) {
    if (changes['locationData'] && this.edit) {
      this.loadMap();
      this.locationData = { ...changes['locationData'].currentValue };
    }
  }

  loadMap() {
    if(this.selectedMap=='google'){
      setTimeout(()=>{
        this.showMap = true;
        const mapOptions = {
          scrollwheel: true,
          zoom: 7,
          maxZoom: 17,
          center: new google.maps.LatLng(12.9716, 77.5946),
          fullscreenControl: false,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
          },
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_CENTER,
          },
          streetViewControl: false,
        };
        let user = this.storage.get('userInfo');
        if(user.defaultLoc != undefined){
          mapOptions.center = new google.maps.LatLng(user.defaultLoc.lat,user.defaultLoc.lng)
          mapOptions.zoom = 9; 
        }
        this.googleMapObj = new google.maps.Map(document.getElementById('locationMap'), mapOptions);
        this.geocoder = new google.maps.Geocoder();
        google.maps.event.addListener(this.googleMapObj,'click', (e) => {
          this.placeMarker(e.latLng);
        });
      },1000)
    }else{
      this.mapService.map("locationMap").then((map) => {
        this.locationMap = map;
        this.showMap = true;
        this.locationMap.onMapClick(($event) => this.mapClickEventListen($event));
      }).catch((error) => {
        console.log(error)
      });
    }
    if (this.locationData != undefined && Object.keys(this.locationData).length > 0 ) {
      setTimeout(()=>{
        this.patchLocationValue();
      },1000)
    }
  }
  placeMarker(location) {
    let latLng={};
    if(this.edit && location.lat && location.lng && this.locationData != undefined && Object.keys(this.locationData).length > 0){
      latLng=new google.maps.LatLng(+location.lat, +location.lng)
    }else{
      latLng=new google.maps.LatLng(+location.lat(), +location.lng())
    }
    if(this.markersArray.length>0){
      this.clearOverlays();
    }
    this.markersArray=[];
    let marker = new google.maps.Marker({
        position: location, 
        map: this.googleMapObj,
        draggable: true
    });
    this.markersArray.push(marker)
    marker.addListener('dragend', (e)=> this.dragToFindAddress(location,e));
    this.googleMapObj.panTo(latLng);//for focusing marked location
    this.googleMapObj.setZoom(15);
    if(!this.edit){
      let obj={
        "params":{
          "latlng":`${+location.lat().toFixed(5)},${+location.lng().toFixed(5)}`
        }
      }
      this.api.transportManagerGoogleMapGeocoder(obj).then((res: any) => {
        if (res.status == 'success') {
          let response=JSON.parse(res.data);
          this.locationObj['name'] = response['results'][0]['formatted_address'];
        }
      }).catch((err) => {
        console.log(err);
      });
    }
    
    //set value
    if(this.edit){
      this.locationObj['lat'] = +location.lat;
      this.locationObj['lng'] = +location.lng;
    }else{
      this.locationObj['lat'] = +location.lat().toFixed(5);
      this.locationObj['lng'] = +location.lng().toFixed(5);
    }
    this.edit=false;
  }
  clearOverlays() {
    for (var i = 0; i < this.markersArray.length; i++ ) {
     this.markersArray[i].setMap(null);
    }
  }
  geocode(decodeConfig: any) {
    return new Promise((resolve, reject) => {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode(decodeConfig, function(results: any, status: any) {
          if(results!=null && results.length){
            resolve(results[0]);
          }else  reject('Error: No response from map.');
        });
    });
  }
  dragToFindAddress(loc,e) {
    let obj={
      "params":{
        "latlng":`${+e.latLng.lat().toFixed(5)},${+e.latLng.lng().toFixed(5)}`
      }
    }
    this.api.transportManagerGoogleMapGeocoder(obj).then((res: any) => {
      if (res.status == 'success') {
        let response=JSON.parse(res.data);
        this.locationObj['lat'] = +e.latLng.lat().toFixed(5);
        this.locationObj['lng'] = +e.latLng.lng().toFixed(5);
        this.locationObj['name'] = response['results'][0]['formatted_address'];
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  scrollToPageTop() {
    // This prevents the page from scrolling down to where it was previously.
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    // This is needed if the user scrolls down during page load and you want to make sure the page is scrolled to the top once it's fully loaded. This has Cross-browser support.
    window.scrollTo(0, 0);
  }

  mapClickEventListen($event,locName?) {
    this.selectedValueClose = true;
    this.locationMarker($event['lngLat']['lat'], +$event['lngLat']['lng']);

    this.locationChanged($event['lngLat']['lat'], +$event['lngLat']['lng'],locName)

    if(this.locationMap&&this.markerId){
      this.locationMap.onDrag([this.markerId], (e) => {
        // console.log(e.target._lngLat['lat']);
        this.locationChanged(e.target._lngLat['lat'], e.target._lngLat['lng'],locName)
        // markerId
      });
    }
  }

  openLocation() {
    if (this.form.value[this.controlName] == '' || this.form.value[this.controlName] == undefined || this.form.value[this.controlName] == null) {
      if (!this.formSubmit) this.form.controls[this.controlName].markAsPending();
      this.emptySuggestions();
    }
    if (Object.keys(this.submittedObj).length > 0 && this.form.value[this.controlName]) {
      if (this.form.value[this.controlName] != this.locationObj['name']) this.selectedValue(this.submittedObj);
    }

    document.getElementById('LocationBtn').click();
    /* if(this.submittedObj && Object.keys(this.submittedObj).length>0) 
      setTimeout(()=>{ this.locationMarker(this.submittedObj['lat'],this.submittedObj['lng']); },300); */

  }
  patchLocationValue() {
    this.submittedObj = { ...this.locationData }
    this.locationObj = { ...this.locationData };
    if (Object.keys(this.locationObj).length > 0) this.selectedValue(this.locationObj);
  }

  locationMarker(lat, lng) {
    if(this.locationMap != undefined){
      this.locationMap.removeMarkerAll();
      this.markerId = 'pickLocation' + Math.round(Math.random() * 10000);
      lat = +lat.toFixed(5); lng = +lng.toFixed(5);
      this.locationMap.marker(
        {
          id: this.markerId,
          content: '<div class="mumb_marker_pin" style="background: #686ab9;"></div>',
          lat: lat,
          lng: lng,
          draggable: true   // <<<<< Important
        }
      );
      this.locationMap.focus({
        lat: lat,
        lng: lng,
        zoom: 14
      });
    }
  }

  locationChanged(lat, lng,locationName?) {

    this.locationObj['lat'] = +lat.toFixed(5);
    this.locationObj['lng'] = +lng.toFixed(5);
    if(locationName && locationName!=''){
      this.locationObj['name'] = locationName;                
    }
    else{
      // this.locationMap.geocoder(
      //   `${lng},${lat}`, (res) => {
      //     try {
      //       // console.log(res.features);
      //       const locations = res.features.map(function (i) { return { center: i.center, name: i.place_name } });
      //       this.locationObj['name'] = locations[0]['name'];
  
  
      //     } catch (er) { console.log(er) };
      //   });
      let obj={
        "params":{
          "latlng":`${+lat.toFixed(5)},${+lng.toFixed(5)}`
        }
      }
      this.api.transportManagerGoogleMapGeocoder(obj).then((res: any) => {
        if (res.status == 'success') {
          let response=JSON.parse(res.data);
          this.locationObj['name'] = response['results'][0]['formatted_address'];
        }
      }).catch((err) => {
        console.log(err);
      });
    }
    this.selectedValueClose = true;
  }
  mapSearchFind(location) {
    location = location.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.mapSearchChangeObserver) {
    new Observable(observer => {
        this.mapSearchChangeObserver = observer;
    }).pipe(debounceTime(1000)) // wait 1000ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
            // your code here
            if(term==''){
                this.mapSearchDataLists = [];
            }
            else{
                if(this.googleSearch){
                  const options = {
                      fields: ["formatted_address", "geometry", "name"],
                      strictBounds: false,
                      types: ["establishment"],
                  };
                  
                  const searchInput: any = document.getElementById('mapSearchBox');// as HTMLInputElement;
  
                  const autocomplete = new google.maps.places.Autocomplete(searchInput, options);
                  // let results = []
                  autocomplete.addListener('place_changed', () => {
                      this.ngZone.run(() => {
                          const getResults = autocomplete.getPlace();
                          /*
                          Example Data 
                          getRestults = {
                              "formatted_address": "7, th street, Subramaniam Colony, Ram Nagar South, Madipakkam, Chennai, Tamil Nadu 600096, India",
                              "geometry": {
                                  "location": {
                                      "lat": 12.9678217,
                                      "lng": 80.2185006
                                  },
                                  "viewport": {
                                      "south": 12.9665866697085,
                                      "west": 80.21685966970848,
                                      "north": 12.9692846302915,
                                      "east": 80.21955763029149
                                  }
                              },
                              "name": "Velachery Railway Station",
                              "html_attributions": []
                          } */
                          try{
                              let name = getResults.formatted_address ? getResults.formatted_address : ''; 
                              let lat = getResults.geometry && getResults.geometry.location && getResults.geometry.location.lat() ? getResults.geometry.location.lat() : '';
                              let lng = getResults.geometry && getResults.geometry.location && getResults.geometry.location.lng() ? getResults.geometry.location.lng() : '';

                              if(lat != '' && lng !=''){
                                if(this.selectedMap == 'google'){
                                  this.googleMapObj.setZoom(13);
                                  this.placeMarker(getResults.geometry.location);
                                }else{
                                  this.locationMarker(+lat,+lng);
                                }
                                this.locationChanged(+lat,+lng,name);
                              }
                          }catch(err){
                              console.log('location bind error',err);
                          }
  
                      });
                  });          

                }else{
                  this.locationMap.geocoder(
                            `${term}`, (res) => {
                                try {
                                    // console.log(res.features);
                                    const locations = res.features.map(function (i) { return { center: i.center, name: i.place_name } });
                                    // this.pickupPoints[this.editIndex]['location'] = locations[0]['name'];
                                    this.locationMap.focus({
                                        lat: locations[0]['center'][1],
                                        lng: locations[0]['center'][0],
                                        zoom: 15
                                    });
                                    this.mapSearchDataLists = [];
                                    this.mapSearchDataLists = locations;
                                } catch (er) { console.log(er) };
                            });
                }                
            }
        });
    }

    this.mapSearchChangeObserver.next(location);

}
  // mapSearchFind(location) {
  //   clearTimeout(this.mapSearchDebounceTimeOut);
  //   this.mapSearchDebounceTimeOut = setTimeout(() => {
  //       this.locationMap.geocoder(
  //         `${location}`, (res) => {
  //           try {
  //             // console.log(res.features);
  //             const locations = res.features.map(function (i) { return { lat: i.center[1], lng: i.center[0], name: i.place_name } });
  //             // this.pickupPoints[this.editIndex]['location'] = locations[0]['name'];
  //             this.locationMap.focus({
  //               lat: locations[0]['lat'],
  //               lng: locations[0]['lng'],
  //               zoom: 15
  //             });
  //             this.locationSuggestions['pickLocation'] = [];
  //             this.locationSuggestions['pickLocation'] = locations;
  //           } catch (er) { console.log(er) };
  //         });

  //   }, 1000);
  // }

  removeCircleAndMarker() {
    this.locationMap.removeMarker(this.markerId);
  }

  selectedValue(value) {
    let obj = {
      lngLat: { lat: value['lat'], lng: value['lng'] }
    };
    if(this.selectedMap=='google'){
      this.placeMarker(value);
    }else{
      this.mapClickEventListen(obj,value['name']);
    }

    this.selectedValueClose = true;
    this.locValueClear = true;
    this.locationSuggestions = {};
  }

  emptySuggestions() {
    if(this.selectedMap != 'google'){
      this.removeCircleAndMarker();
    }else{
      this.clearOverlays();
    }
    this.locationSuggestions = {};
    this.selectedValueClose = false;
    this.locationObj = {};
    if (!this.mandatory) this.form.controls[this.controlName].patchValue('');
  }

  resetLocationState() {
    this.submittedObj = {};
    this.locationObj = {};
    this.locationSuggestions = {};
    this.selectedValueClose = false;
    this.locValueClear = false;

    if (this.selectedMap !== 'google') {
      if (this.locationMap && this.markerId) {
        this.removeCircleAndMarker();
      }
    } else if (this.markersArray && this.markersArray.length > 0) {
      this.clearOverlays();
      this.markersArray = [];
    }

    if (this.form && this.controlName && this.form.get(this.controlName)) {
      this.form.get(this.controlName).patchValue('');
      this.form.get(this.controlName).markAsUntouched();
      this.form.get(this.controlName).updateValueAndValidity();
    }
  }

  submitLocation() {
    if (Object.keys(this.locationObj).length > 0 && this.locationObj['name']) {
      this.submittedObj = { ...this.locationObj };
      this.locValueClear = true;
      this.result.emit(this.locationObj);
      this.formSubmit = false;
      this.form.controls[this.controlName].patchValue(this.locationObj['name']);
      this.form.get(this.controlName).markAsTouched();
      this.form.get(this.controlName).updateValueAndValidity();

      this.modalClose();
    } else if (!this.mandatory) {
      this.locValueClear = false;
      this.modalClose();
    }
  }

  cancelLocation(e) {
    e.stopPropagation();
    this.locValueClear = false;
    this.submittedObj = {};
    this.formSubmit = true;
    this.locationObj = {};
    if (!this.mandatory) this.result.emit(false);
    this.form.controls[this.controlName].patchValue("");
    this.form.get(this.controlName)?.markAsTouched();
    this.form.get(this.controlName)?.updateValueAndValidity();
  }

  modalClose() {
    if (Object.keys(this.locationObj).length <= 0 || Object.keys(this.submittedObj).length <= 0) this.locValueClear = false
    this.modalHide.nativeElement.click();
  }


  /* checking error in fields*/
  public checkError = (controlName: string, errorName: string) => {
    return this.form.controls[controlName].hasError(errorName);
  }

}
